import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../lib/api';
import { Search, ArrowLeft } from 'lucide-react';

export default function TermsPage() {
  const [terms, setTerms] = useState(null);
  useEffect(() => { api.get('/legal/terms').then(r => setTerms(r.data)).catch(() => {}); }, []);

  return (
    <div className="min-h-screen bg-[#F7F9FC] pb-16">
      <nav className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-[#E2E8F0]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-2">
            <img src="/icon-nav.png" alt="Local Luc" className="h-12 w-12 rounded-xl object-cover" />
          </Link>
        </div>
      </nav>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <Link to="/" className="inline-flex items-center gap-1 text-sm text-[#64748B] hover:text-[#0268C4] mb-6 transition-colors">
          <ArrowLeft className="w-4 h-4" /> Back
        </Link>
        <h1 data-testid="terms-heading" className="font-heading text-3xl font-semibold tracking-tight text-[#0F2951] mb-2">Terms of Service</h1>
        <p className="text-sm text-[#64748B] mb-8">Last updated: {terms?.last_updated || 'April 10, 2026'}</p>
        {terms?.content && (
          <div className="space-y-6">
            {Object.entries(terms.content).map(([key, value]) => (
              <div key={key} className="bg-white rounded-2xl border border-[#E2E8F0] p-6">
                <h2 className="font-heading text-base font-medium text-[#0F2951] mb-2 capitalize">{key.replace(/_/g, ' ')}</h2>
                <p className="text-sm text-[#64748B] leading-relaxed">{value}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
